import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import {getQvctSurveyOpinion} from "./getters";

const initialState = {
    qvctSurveys: [],
    qvctSurveyStats: {},
    qvctSurveyOpinion: {},
    qvctSurveysCategoriesWithoutChildren: [],
    qvctSurveysRootCategories: [],
    qvctSurveysAnswersType: [],
    qvctSurveyQuestions: {},
    qvctSurveyForResponse: null,
    qvctSurveyResponses: {},
    qvctSurveyStatus:[]
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
